'use strict';
import angular from 'angular';
import './scripts/inventorycalendar.ctrls';
import './scripts/inventorycalendar.services';

import inventoryCalendarHtmlUrl from './views/inventoryCalendar.html';

angular.module('inventorycalendar', [
    'inventorycalendar.ctrls',
    'inventorycalendar.services'
])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('inventoryCalendar',   {
                parent: 'layout',
                url: '/admin/inventoryCalendar',
                templateUrl: inventoryCalendarHtmlUrl,
                controller: 'InventoryCalendarController',
            })
    }]);